import { CoordMap } from ".";
var mockSuccessResultCode = "SUCCESS";
var mockGridStateServiceResponse = {
    resultCode: mockSuccessResultCode
};
var MockGridStateService = /** @class */ (function () {
    function MockGridStateService() {
    }
    MockGridStateService.prototype.subscribe = function (handler) {
        return {
            unsubscribe: function () {
                return;
            }
        };
    };
    MockGridStateService.prototype.getCurrentState = function () {
        return { activeGridId: null };
    };
    MockGridStateService.prototype.getProjectBaselineSummary = function () {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.createProjectBaseline = function (displayBaselineBars) {
        return mockSuccessResultCode;
    };
    MockGridStateService.prototype.removeProjectBaseline = function () {
        return mockSuccessResultCode;
    };
    MockGridStateService.prototype.resetProjectBaseline = function () {
        return mockSuccessResultCode;
    };
    MockGridStateService.prototype.setBaselineBarsDisplay = function (displayBaselineBars) {
        return mockSuccessResultCode;
    };
    MockGridStateService.prototype.getAccessLevel = function () {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.setAutomationColumnIds = function (automationColumnIds) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.getColumnCount = function () {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.getRowCount = function () {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.getColumns = function () {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.getColumnsByIndex = function (indexes) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.getRowsByIndex = function (indexes) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.getCellByRowAndColumnId = function (rowId, columnId) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.getBroker = function (brokerArgs) {
        return {
            subscribe: function () {
                return {
                    unsubscribe: function () {
                        return;
                    }
                };
            },
            unsubscribe: function () {
                return;
            },
            GRID: {
                getInfo: function () {
                    return Promise.resolve({
                        numberOfColumns: 0,
                        numberOfRows: 0,
                        id: 1,
                        syncMarkerToken: "123",
                        audit: {
                            createdAt: 1,
                            createdBy: 1,
                            modifiedAt: 1,
                            modifiedBy: 1
                        },
                        traceId: "123",
                        hasFormulas: false,
                        hasConditionalFormats: false,
                        hasFilters: false,
                        hasInboundLinks: false,
                        hasOutboundLinks: false,
                        hasSheetSummary: false
                    });
                }
            },
            CELL: {
                getByCoords: function (coords) { return Promise.resolve([]); },
                getMapByCoords: function (coords) { return Promise.resolve(new CoordMap()); },
                setText: function (coords, text) { return Promise.resolve(true); },
                setNumber: function (coords, numberById) { return Promise.resolve(true); }
            },
            ROW: {
                getOrder: function () { return Promise.resolve([]); },
                getById: function (ids) { return Promise.resolve(new Map()); },
                getStructure: function () { return Promise.resolve([]); }
            },
            COLUMN: {
                getOrder: function () { return Promise.resolve([]); },
                getById: function (ids) { return Promise.resolve(new Map()); },
                getAll: function () { return Promise.resolve(new Map()); },
                getOptionsById: function () { return Promise.resolve(new Map()); }
            }
        };
    };
    MockGridStateService.prototype.insertColumnAndSave = function (columnName, columnType, validationType, insertCallback, pickListData, isLocked, columnDescription, targetIndex) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.removeColumnAndSave = function (columnId) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.rowExists = function (rowId) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.rowExistsForGrid = function (rowId, gridId) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.isLoadComplete = function () {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.saveRowForCallback = function (rowId, callback, forceSave, rightPanelRequest) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.refreshDiscussionIconForRow = function (rowId, balloonType, updatedValue) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.isRowLockRestricted = function (rowId) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.isRowSelectable = function (rowId) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.isRowFilteredOut = function (rowId) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.updateGridDataTimestampByGridId = function (gridId, dataTimestamp, modifyDateTime) {
        return mockGridStateServiceResponse;
    };
    MockGridStateService.prototype.useTemplate = function (gridId) {
        return;
    };
    MockGridStateService.prototype.updateLegacyGridState = function (gridState) {
        return;
    };
    return MockGridStateService;
}());
export { MockGridStateService };
//# sourceMappingURL=MockGridStateService.js.map